import React from "react";
import LeadLink from "web/react/components/lead-link/lead-link";
import { useProductClick } from "web/react/hooks/use-product-click/use-product-click";
import { useProductCardContext } from "./product-card";

interface ProductCardLinkProps {
    reason: string;
    predicate: boolean;
    className?: string;
    children?: any;
    onClick?: () => void;
}

function ProductCardLink({
    children,
    reason,
    className,
    predicate,
    onClick,
}: ProductCardLinkProps): React.ReactElement {
    const {
        id,
        uid,
        url,
        slug,
        image_url: imageURL,
        in_stock: inStock,
        link_id: linkId,
        lead_url: leadURL,
        affiliate_promo_url: affiliatePromoURL,
        context_type: contextType,
        overlay_enabled: overlayEnabled,
        use_overlay_on_mobile: useOverlayOnMobile,
    } = useProductCardContext();

    const { onClick: onProductClick } = useProductClick({
        id: id.toString(),
        productUrl: url,
        productImageUrl: imageURL || undefined,
        inStock,
        shouldRedirect: false,
        overlayEnabled: overlayEnabled,
        useOverlayOnMobile,
        productUid: uid,
        productSlug: slug,
        reason: contextType ? `${contextType}-${reason}` : undefined,
        linkId: linkId?.toString(),
        href: url,
        isLeadLink: predicate,
        openInNewTab: predicate,
    });

    function handleLeadLinkClick(callback, event): void {
        onClick?.();
        onProductClick(event);
        callback(event);
    }

    function handleClick(event): void {
        onClick?.();
        onProductClick(event);
    }

    if (predicate) {
        return (
            <LeadLink
                href={leadURL as string}
                productId={id.toString()}
                openInNewTab={true}
                affiliatePromoUrl={affiliatePromoURL || undefined}
                reason={contextType ? `${contextType}-${reason}` : undefined}
                className={className}
                rel="nofollow"
                beforeOnClick={handleLeadLinkClick}
            >
                {children}
            </LeadLink>
        );
    }

    return (
        <a href={url} className={className} onClick={handleClick}>
            {children}
        </a>
    );
}

export default ProductCardLink;
